<template>
    <Card>
        <template v-slot:icon><i class="fas fa-building"/></template>
        <template v-slot:title>{{ __('general.stores') }}</template>
        <template v-slot:description>{{ __('actions.store.deactivate_chosen_multiple') }}</template>
        <template v-slot:toolbar>
            <button class="btn btn-sm"
                    :class="{'btn-light-primary': !showAddStores, 'btn-outline-primary': showAddStores}"
                    @click="showAddStores = !showAddStores"
                    :disabled="disabled"
            >
                <i class="fas fa-plus-square"/>
                {{ __('actions.store.add_stores') }}
            </button>
        </template>

        <IntegrationSettingsStoreList v-show="enabledStores.length > 0"
                                      :integration="integration"
                                      :stores="enabledStores"
                                      v-model="selectedStores"
        />

        <div v-if="enabledStores.length === 0" class="text-muted">
            {{ __('general.no_stores_linked').withDot() }}
        </div>

        <div v-if="selectedStoreUuids.length > 0" class="mt-3 d-flex justify-content-end">
            <button class="btn btn-sm"
                    :class="{'btn-danger': enabledCount > 0, 'btn-secondary': enabledCount === 0}"
                    :disabled="enabledCount === 0 || disabled"
                    @click="disableSelectedStores"
            >
                <i class="fas fa-minus-circle"/>
                {{ __('actions.store.deactivate_chosen_multiple') }}
            </button>
        </div>

        <div v-show="showAddStores && !disabled" class="card card-body border-primary bg-light-primary my-3">
            <h3>{{ __('general.thing.available_multiple', {thing: __('general.stores')}) }}</h3>
            <IntegrationSettingsAddStores :integration="integration" :stores="availableStores"/>
        </div>
    </Card>
</template>

<script>
import IntegrationSettingsStoreList from "./IntegrationSettingsStoreList.vue";
import IntegrationSettingsAddStores from "./IntegrationSettingsAddStores.vue";
import IntegrationSettingsCard from "./IntegrationSettingsCard.vue";
import Card from "@components/Cards/Card.vue";

export default {
    components: {Card, IntegrationSettingsCard, IntegrationSettingsAddStores, IntegrationSettingsStoreList},

    props: {
        integration: Object,
        enabledStores: Array,
        availableStores: Array,
        disabled: Boolean
    },

    data() {
        return {
            showAddStores: false,
            selectedStores: [],
            selectedAvailableStores: [],
        }
    },

    methods: {
        disableSelectedStores() {
            this.$inertia.post(this.$route('integration.stores.unlink', [this.integration.code]), {
                storeUuids: this.selectedStoreUuids
            })
            this.selectedStores = [];
        },
    },

    computed: {
        enabledCount() {
            let out = 0
            for (let selected in this.selectedStores) {
                if (this.selectedStores[selected]) {
                    out++
                }
            }
            return out
        },

        selectedStoreUuids() {
            let out = []
            for (let storeUuid in this.selectedStores) {
                if (this.selectedStores[storeUuid]) {
                    out.push(storeUuid)
                }
            }
            return out
        },
    }
}
</script>
